<template>
  <!-- <div style="background-color: #fff; padding: 10px"> -->
  <!-- 搜索 -->
  <div ref="topDom" class="header-bar">
    <div class="bar-lef">
      <div class="lef-group">
        <div class="group-one">
          <a-input
              v-model:value="searchForm.rname"
              :loading="searchLoading"
              allowClear
              placeholder="房型名称"
              @search="getTableData"
          ></a-input>
        </div>
        <div class="group-one">
          <a-input
              v-model:value="searchForm.gname"
              :loading="searchLoading"
              allowClear
              placeholder="分组名称"
              @search="getTableData"
          ></a-input>
        </div>
      </div>
      <div class="lef-one">
        <a-input-search
            v-model:value="searchForm.hname"
            :loading="searchLoading"
            allowClear
            placeholder="请输入房间名称"
            @search="getTableData"
        >
        </a-input-search>
      </div>
    </div>
  </div>

  <!-- 表格 -->
  <a-table
      :columns="columns"
      :dataSource="dataSource"
      :loading="searchLoading"
      :pagination="false"
      :scroll="{ x: columns.length > 6 ? 1500 : 0, y: tableHeight }"
      class="table"
      size="small"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key == 'operation'">
        <a-button type="link" @click="handleEdit(record)">修改</a-button>
      </template>
    </template>
  </a-table>

  <!-- 弹窗 -->
  <a-modal
      v-model:visible="visibleAdd"
      :title="modalTitle"
      :width="400"
      @ok="addSave"
  >
    <a-form
        ref="formRef"
        :label-col="{ span: 4 }"
        :model="addForm"
        :rules="rules"
        hideRequiredMark
        labelAlign="left"
    >
      <a-form-item label="房间：" name="name">
        <a-input
            v-model:value="addForm.name"
            disabled
            placeholder="请输入姓名"
            style="width: 100%"
        ></a-input>
      </a-form-item>
      <a-form-item label="简单：" name="clean_easy">
        <a-input
            v-model:value="addForm.clean_easy"
            placeholder="请输入费用"
            style="width: 100%"
        ></a-input>
      </a-form-item>

      <a-form-item label="标准：" name="clean_norm">
        <a-input
            v-model:value="addForm.clean_norm"
            placeholder="请输入费用"
            style="width: 100%"
        ></a-input>
      </a-form-item>
      <a-form-item label="高级：" name="clean_expert">
        <a-input
            v-model:value="addForm.clean_expert"
            placeholder="请输入费用"
            style="width: 100%"
        ></a-input>
      </a-form-item>
    </a-form>
  </a-modal>

  <!-- 分页 -->
  <MyPagination
      :pageTotal="pageTotal"
      class="pagination"
      @onShowSizeChange="onShowSizeChange"
      @pageChange="pageChange"
  />
  <!-- </div> -->
</template>

<script>
import {nextTick, onMounted, reactive, toRefs, watch} from "vue";
import {getHouseList, taskCleanFeeList, taskSaveCleanFee} from "@/api/api";
// import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
import useUtils from "@/hooks/useUtils.js"; //工具库
import usePagination from '@/hooks/usePagination'; // 分页hook
import store from "@/store/pms/landlord/index"; //VUEX
import {message} from "ant-design-vue";
import {verifyPrice} from "@/common/validator";

export default {
  //   components: {
  //     ExclamationCircleOutlined,
  //   },
  setup() {
    let {countTable, imgCut} = useUtils();

    // 搜索
    const search = reactive({
      topDom: "",
      searchLoading: false,
      searchForm: {
        hname: "",
        rname: "",
        gname: "",
        start: 0,
        limit: store.getters.getPageSize,
      },
    });

    // 表格
    const table = reactive({
      tableHeight: "",
      dataSource: [],
      initColumns: [],
      columns: [
        {
          title: "房间",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "房型",
          dataIndex: "rname",
          key: "rname",
        },
        {
          title: "分组",
          dataIndex: "gname",
          key: "gname",
        },
        {
          title: "简单",
          dataIndex: "clean_easy",
          key: "clean_easy",
          customRender: ({text}) => {
            if (!text) {
              return "-";
            }
          },
        },
        {
          title: "标准",
          dataIndex: "clean_norm",
          key: "clean_norm",
          customRender: ({text}) => {
            if (!text) {
              return "-";
            }
          },
        },
        {
          title: "高级",
          dataIndex: "clean_expert",
          key: "clean_expert",
          customRender: ({text}) => {
            if (!text) {
              return "-";
            }
          },
        },
        {
          title: "操作",
          dataIndex: "operation",
          key: "operation",
          align: "center",
        },
      ],
      getTableData() {
        search.searchLoading = true;
        taskCleanFeeList(search.searchForm)
            .then((res) => {
              table.dataSource = res.data.list;
              pagination.pageTotal = res.data.count;
              search.searchLoading = false;
            })
            .catch(() => {
              search.searchLoading = false;
            });
      },
      handleEdit(item) {
        modal.modalTitle = "默认保洁费";
        modal.searchRoom();
        nextTick(() => {
          modal.addForm.name = item.name;
          modal.addForm.hid = item.id;
          modal.addForm.clean_easy = item.clean_easy;
          modal.addForm.clean_norm = item.clean_norm;
          modal.addForm.clean_expert = item.clean_expert;
        });
        modal.visibleAdd = true;
      },
    });

    // 弹窗
    const modal = reactive({
      modalTitle: "",
      visibleAdd: false,
      formRef: "", //表单验证
      addForm: {
        hid: "",
        name: "",
        clean_easy: "",
        clean_expert: "",
        clean_norm: "",
      },
      rules: {
        clean_easy: [
          {
            required: true,
            validator: verifyPrice,
            trigger: "blur",
          },
        ],
        clean_norm: [
          {
            required: true,
            validator: verifyPrice,
            trigger: "blur",
          },
        ],
        clean_expert: [
          {
            required: true,
            validator: verifyPrice,
            trigger: "blur",
          },
        ],
      },
      // 保存
      isLoading: false,
      addSave() {
        if (modal.isLoading) {
          return;
        }
        modal.formRef.validate().then(() => {
          modal.isLoading = true;
          taskSaveCleanFee(modal.addForm)
              .then((res) => {
                message.success(res.msg);
                nextTick(() => {
                  modal.isLoading = false;
                });
                modal.visibleAdd = false;
                table.getTableData();
              })
              .catch(() => {
                modal.isLoading = false;
              });
        });
      },
      roomList: [],
      searchRoom() {
        getHouseList({
          start: 0,
          limit: 99,
        }).then((res) => {
          modal.roomList = res.data.list;
        });
      },
      throttle: false,
      throttleInput: "",
      roomFilter(input) {
        modal.throttleInput = input;
        if (modal.throttle) {
          return;
        }
        modal.throttle = true;
        setTimeout(() => {
          getHouseList({
            start: 0,
            limit: 99,
            name: modal.throttleInput,
          }).then((res) => {
            modal.roomList = res.data.list;
            modal.throttle = false;
          });
        }, 1000);
      },
    });

    // 分页;
    let pagination = usePagination(table.getTableData, search.searchForm);

    watch(
        () => store.state.ContentHeight,
        () => {
          table.tableHeight = countTable(search.topDom) - 10;
        }
    );

    onMounted(() => {
      table.getTableData();
      table.tableHeight = countTable(search.topDom) - 10;
    });

    return {
      ...toRefs(search),
      ...toRefs(table),
      ...toRefs(modal),
      ...toRefs(pagination),
      imgCut,
    };
  },
};
</script>

<style lang="scss">
.weixin {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .QR {
  }

  .info {
    font-weight: bold;
  }

  .tips {
    color: #f5a623;
    margin-top: 20px;
  }
}

.drawer {
  position: absolute;

  .header {
    height: 60px;
    border-bottom: 1px solid #f2f2f2;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;

    .title {
    }

    .status {
    }
  }

  .content {
    padding: 20px;

    .title {
      padding: 10px 0;
    }

    .info {
      display: flex;
      padding: 7px 0;

      .lef {
        width: 100px;
      }

      .rig {
        width: 400px;
      }
    }
  }

  .operate {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    bottom: 0;
    width: 450px;
    height: 60px;
    border-top: 1px solid #f2f2f2;
    background-color: #fff;

    .lef {
    }

    .rig {
    }
  }
}

.fRed {
  color: red;
}

.bar {
  border-radius: 10px;
  padding: 2px 10px;
  height: 20px;
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 12px;
}

.add-box {
  width: 100%;
  display: flex;
  // justify-content: space-between;
  padding: 0 10px;

  .add-lef {
    flex: 1;
    margin-right: 40px;
  }

  .add-rig {
    flex: 1;
  }
}

.checkbox {
  margin-left: 90px;
  margin-bottom: 24px;
}
</style>
